import { Directive, Output, Input, EventEmitter, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[appDragDrop]'
})
export class DragDropDirective {

  @Output() onFileDropped = new EventEmitter<any>();
  @Output() fileDropped = new EventEmitter<any>();

  //Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    let target = evt.target;
    if (target.parentElement.parentElement) { // #2099
      target.parentElement.parentElement.classList.add("hovered");
    }
  }
	
  //Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    if(evt.target.parentElement.parentElement && evt.target.parentElement.parentElement.className.indexOf("upload") == -1) // #2099
    {
      let target = evt.target;
      if (target.parentElement.parentElement) { // #2099
        target.parentElement.parentElement.classList.remove("hovered");
        target.parentElement.parentElement.classList.add("unupload");
      }
    }
  }
	
  //Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    let target = evt.target;
    if (target.parentElement.parentElement) { // #2099
      target.parentElement.parentElement.classList.add("upload");
    }
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.onFileDropped.emit(files)
      this.fileDropped.emit(true);
    }
  }
	
  @HostListener('change', ['$event']) public onchange(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    console.log(evt);
    let target = evt.target;
    if (target.parentElement.parentElement) { // #2099
      target.parentElement.parentElement.classList.add("upload");
    }
  }
}